import React, { useState, useEffect } from 'react';
import { FaChevronUp } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const ScrollToTop = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;
      
      setScrollProgress(scrollPercent);
      setIsVisible(scrollTop > 300); // Mostrar después de 300px de scroll
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!isVisible) return null;

  return (
    <div className="scroll-to-top" onClick={scrollToTop} title={t('scrollToTop', 'Ir arriba')}>
      <div className="progress-ring">
        <svg className="progress-ring-svg" width="60" height="60">
          <circle
            className="progress-ring-circle-bg"
            stroke="rgba(255, 255, 255, 0.1)"
            strokeWidth="2"
            fill="transparent"
            r="26"
            cx="30"
            cy="30"
          />
          <circle
            className="progress-ring-circle"
            stroke="#ffffff"
            strokeWidth="2"
            fill="transparent"
            r="26"
            cx="30"
            cy="30"
            style={{
              strokeDasharray: `${2 * Math.PI * 26}`,
              strokeDashoffset: `${2 * Math.PI * 26 * (1 - scrollProgress / 100)}`,
            }}
          />
        </svg>
        <div className="scroll-icon">
          <FaChevronUp />
        </div>
      </div>
    </div>
  );
};

export default ScrollToTop;
